// extracted by mini-css-extract-plugin
export default {"composer":"MemoryChatComposer_composer-k7u","composerError":"MemoryChatComposer_composerError-puv","composerField":"MemoryChatComposer_composerField-y9H"};